import PropTypes from "prop-types";
import { Breadcrumbs } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import ConfirmationDialog from "./ConfirmationDialog";
import { ARE_YOU_SURE_YOU_WANT_TO_LEAVE_PAGE_DIALOG_MESSAGE } from "../../util/messageConstants";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: {
    textDecoration: "none",
    cursor: "pointer",
    color: theme.palette.secondary.swaGray,
    "&:hover": {
      color: `${theme.palette.secondary.swaGray}`,
      textDecoration: "underline",
    },
  },
  activeBreadcrumb: {
    textDecoration: "none",
    cursor: "pointer",
    pointerEvents: "none",
    color: theme.palette.secondary.swaBlue,
    "&:hover": {
      color: `${theme.palette.secondary.swaBlue}`,
      textDecoration: "underline",
    },
  },
}));

const StarsBreadcrumbs = (props) => {
  const classes = useStyles();
  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [redirectLink, setRedirectLink] = useState("");
  const history = useHistory();

  const breadcrumbsRoute = (breadcrumbLink) => {
    if (props.isConfirmationRequired === true) {
      setConfirmationDialogOpen(true);
      setRedirectLink(breadcrumbLink);
    } else {
      history.push(breadcrumbLink);
    }
  };

  const breadcrumbsWarningNoClicked = () => {
    setConfirmationDialogOpen(false);
  };
  const breadcrumbsWarningYesClicked = () => {
    setConfirmationDialogOpen(false);
  };

  return (
    <>
      <Breadcrumbs marginLeft="2rem" marginTop="20px" separator="/" area-label="breadCrumbs">
        {props.breadcrumbsList.map((breadcrumb, index) => (
          <div key={breadcrumb}>
            <div
              className={props.breadcrumbsList.length === index + 1 ? classes.activeBreadcrumb : classes.breadcrumbs}
              onClick={() => breadcrumbsRoute(props.breadcrumbsLinks[index])}
            >
              {breadcrumb}
            </div>
          </div>
        ))}
      </Breadcrumbs>
      {isConfirmationDialogOpen && (
        <ConfirmationDialog
          message={ARE_YOU_SURE_YOU_WANT_TO_LEAVE_PAGE_DIALOG_MESSAGE(props.cancelActionType)}
          isDialogOpen={isConfirmationDialogOpen}
          redirectTo={redirectLink}
          handleNoButtonClicked={breadcrumbsWarningNoClicked}
          handleYesButtonClicked={breadcrumbsWarningYesClicked}
        />
      )}
    </>
  );
};
StarsBreadcrumbs.propTypes = {
  breadcrumbsList: PropTypes.array.isRequired,
  isConfirmationRequired: PropTypes.bool.isRequired,
  breadcrumbsLinks: PropTypes.array.isRequired,
  cancelActionType: PropTypes.string,
};
export default StarsBreadcrumbs;
